import ApiService from './api.service'
const main = '/session'
const employeeWork = '/employeeWork'
const employee = '/employee'
export default {

    getByRequirement(id) {
        return ApiService.get(`/staff-list-requirement/${id}`)
    },
    selectVakant(id) {
        return ApiService.put(`/employee/connect/${id}`)
    },
    getSelectedVakants() {
        return ApiService.get(`${employee}/employeeStaffVacancyList`)
    },
    // added Abdurasul
    returnDocument(id){
        return ApiService.get(`${employee}/return-document/${id}`)
    },
    read(id) {
        return ApiService.get(`${employee}/employeeStatus-byStatusId/${id}`)
    },
    getUnreadStatus: async function () {
        return ApiService.get(`${employee}/unread-statuses`)
    },
    getStatusHistory: async function (id,staffId) {
        return ApiService.get(`/employee/employee-status-history/${id}/${staffId}`)
    },
    createEmployeePassportDate: async function (data) {
        return ApiService.post(`${employee}/create`, data)
    },
    getEmployeePassportEndDate: async function (data) {
        return ApiService.post(`${employee}/after10year`, data)
    },
    getEmployeePassportDate: async function (id) {
        return ApiService.get(`${employee}/get-by-id/${id}`)
    },
    getEmployee: async function () {
        return ApiService.get(`${main}/currentUser`)
    },
    getList: async function (data) {
        return ApiService.post(`${main}/list`, data)
    },
    getEmployeeContact: async function (data) {
        return ApiService.post(`${main}/get-by-chat`, data)
    },
    getEmployeeTiketContact: async function (data) {
        return ApiService.post(`${main}/get-by-chat`, data)
    },
    getById: async function (id) {
        return ApiService.get(`${employee}/get-by-id/${id}`)
    },
    delete: async function (id) {
        return ApiService.delete(`${main}/delete/${id}`)
    },
    update: async function (data) {
        return ApiService.post(`${main}/update`, data)
    },
    create: async function (data) {
        return ApiService.post(`${main}/create`, data)
    },
    getByDepId(data) {
        return ApiService.post(`${main}/get-by-depId/${data.depId}`, data.params)
    },
    getByDepIdAndByName(data) {
        return ApiService.post(`${main}/get-by-name`, data)
    },

    // API PASSPORT DATA
    getPassportData: async function (data) {
        return ApiService.post(`${main}/get-by-url`, data)
    },
    //TRANSFER EMPLOYE
    transfer: async function (data) {
        return ApiService.post(`${employeeWork}/transfer`, data)
    },
    //DISMISS
    dismiss: async function (data) {
        return ApiService.post(`${employeeWork}/dismissal`, data)
    },
    getPhotoByte: async function (id) {
        return ApiService.get(`/employeePhoto/employee-photo/${id}`)
    },


    getPassportDataPnfl: async function (pinfl) {
        return ApiService.get(`${employee}/passport-info?pinfl=${pinfl}` );
    },

}
